import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetHasStripeAccount } from '../state';
import fetchWithToken from '../services';

const CheckStripeAccount = () => {
    const setHasStripeAccount = useSetHasStripeAccount();
    const navigate = useNavigate();

    useEffect(() => {
        const checkStripeAccount = async () => {
            try {
                const response = await fetchWithToken('/check-stripe-account', {
                    method: 'POST',
                });
                const data = await response.json();
                console.log('Data retrieved from check-stripe-account:', data)

                if (data.hasStripeAccount === true) {
                    setHasStripeAccount(true);
                } else {
                    console.log('User has not created Stripe account');
                    console.log('navigating to create stripe account');
                    setHasStripeAccount(false);
                }
            } catch (error) {
                console.error('Error checking if user has Stripe account:', error);
                navigate('/error');
            }
        };

        checkStripeAccount();
    }, []); // eslint-disable-next-line react-hooks/exhaustive-deps

    return null;
};

export default CheckStripeAccount;
